import { env } from '../../../config/env';
import { LmsIcsFetchError } from './lmsIcsFetchError';

/**
 * @param {Response} res
 * @returns {Promise<LmsIcsFetchError>}
 */
async function errorFromResponse(res) {
    let body = {};
    try {
        body = await res.json();
    } catch {
        /* ignore */
    }
    const detail = body && typeof body === 'object' ? body.detail : null;
    if (detail && typeof detail === 'object' && typeof detail.code === 'string') {
        return new LmsIcsFetchError(
            detail.code,
            typeof detail.message === 'string' ? detail.message : res.statusText || 'Request failed',
            res.status,
        );
    }
    if (typeof detail === 'string') {
        return new LmsIcsFetchError('feed_fetch_failed', detail, res.status);
    }
    return new LmsIcsFetchError(
        'feed_fetch_failed',
        res.statusText || `Request failed (${res.status})`,
        res.status,
    );
}

/**
 * Fetch ICS text via backend proxy (same origin as API — no LMS CORS).
 *
 * @param {string} userId
 * @param {AbortSignal} [signal]
 * @returns {Promise<string>}
 */
export async function fetchLmsIcsForUser(userId, signal) {
    const base = (env.backendBaseUrl || '').replace(/\/$/, '');
    if (!base) {
        throw new LmsIcsFetchError(
            'feed_fetch_failed',
            'Backend base URL is not configured (ICS proxy unavailable).',
            0,
        );
    }

    const url = `${base}/api/lms/ics?user_id=${encodeURIComponent(userId)}`;
    const res = await fetch(url, {
        method: 'GET',
        credentials: 'omit',
        redirect: 'follow',
        signal,
        headers: {
            Accept: 'text/calendar, application/ics, text/plain;q=0.9, */*;q=0.1',
        },
    });

    if (!res.ok) {
        throw await errorFromResponse(res);
    }

    const text = await res.text();
    if (!text || !text.trim()) {
        throw new LmsIcsFetchError('feed_empty', 'Calendar feed returned no data.', res.status);
    }

    return text;
}
